import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ThinArrowUpwardIconSvg = (<svg viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
        <path d="M18.4 10.4L12 4.8M12 4.8V19.2M12 4.8L5.6 10.4"/>
    </svg>
)
const ThinArrowUpwardIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ThinArrowUpwardIconSvg}
    </SvgIcon>
);
export default ThinArrowUpwardIcon